import {TaskEvent} from "@core/model";
import {useState} from "react";
import {ButtonBase} from "@mui/material";
import {Event} from "./Event";
import {Time} from "./Time";

const EventTime = ({
  event,
  minimize = false,
}: {
  event: TaskEvent;
  minimize?: boolean;
}) => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <ButtonBase
      onClick={() => setOpen(o => !o)}
      sx={{
        flex: 1,
        px: 2,
        py: 1,
        flexDirection: minimize ? "column" : "row-reverse",
        justifyContent: "start",
        alignItems: "start",
      }}>
      <Event event={event} open={open} />
      <Time day={event.start} event={event} minimize={minimize} />
    </ButtonBase>
  );
};

export {EventTime};
